export default "__VITE_ASSET__De0mk0OY__"